import { Injectable } from '@angular/core';

/** 'expiredDuringRun': the session ended while an upload batch was running in this window. */
export type SignInReason = 'expired' | 'expiredDuringRun' | 'signedOut';

/**
 * Leaves the session with a full page load of /sign-in, which drops every signal, hub connection and upload snapshot
 * of the old session. Works for app://privanot (desktop), the dev server and nginx (hosted).
 */
@Injectable({ providedIn: 'root' })
export class SessionNavigator {
    public toSignIn(reason?: SignInReason): void {
        window.location.assign(reason ? `/sign-in?reason=${reason}` : '/sign-in');
    }
}
